$(function() {
    $(".home").css("opacity", "1")
    $(".main-map-home, .map--erdely, .map--felvidek, .map--delvidek").css("transform", "scale(1)")
    $(".main-text, .secondary-content, cp-text-block, .slider-text, .slider-images, .main-map-theatres").css("transform", "translateX(0)")
});